import { Role, ROLES } from './roles';

export type RoleRouteRule = {
  path: string;
  roles: Role[];
};

/**
 * Routes that require at least one of the listed roles.
 * Omit a path here to leave it open to every authenticated user.
 *
 * Matching: exact path or any nested path (`/identity-management/foo`).
 */
export const ROLE_ROUTE_RULES: RoleRouteRule[] = [
  { path: '/identity-management', roles: [ROLES.ADMIN] },
  { path: '/organization-management', roles: [ROLES.ADMIN] },
  { path: '/subscription-plans', roles: [ROLES.ADMIN] },
  { path: '/checkout', roles: [ROLES.ADMIN] },
  { path: '/plans-billing', roles: [ROLES.ADMIN] },
  { path: '/usage-config', roles: [ROLES.SUPER_ADMIN] },
];

export const canAccessRoute = (pathname: string, userRoles: string[] = []) => {
  const rule = ROLE_ROUTE_RULES.find(
    (item) => pathname === item.path || pathname.startsWith(`${item.path}/`)
  );

  if (!rule?.roles.length) {
    return true;
  }

  return rule.roles.some((role) => userRoles.includes(role));
};
